export default {"src":"/accounts/_next/static/media/EmailBlue.0f6f2ba5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};